import Enum from '@/modules/core/app/models/abstracts/Enum';

export class AccountStatusEnums extends Enum {
  static ACCOUNT_STATUS_ACTIVE = 'active';
}

export const AccountStatus = {
  ACTIVE: 'active',
  AUTH_ERROR: 'auth_error',
  INSUFFICIENT_PERMISSION: 'insufficient_permissions',
  SUSPENDED: 'suspended',
};

export const CycleTypes = {
  MONTHLY: 'monthly',
  REPEATING: 'repeating',
  CUSTOM: 'custom',
};

export const BUDGET_PACING_FORM_ALERTS = [5, 10, 20, 30, 40, 50];

export const BudgetPacingRoute = {
  BUDGETPACINGS: 'budgetpacings',
};

export const BudgetPacingPathName = {
  BUDGETPACINGS: 'budgetpacings',
  BUDGETPACINGFORM_NEW: 'budgetpacingform:new',
  BUDGETPACINGSDETAILPAGE: 'budgetpacingsdetailspage',
};
